/**
 * Page aside navigation.
 */
export const contentScrollNav = () => {

	const blogContent = document.querySelector( '.js-content' )
	const nav = document.querySelectorAll( '.js-content-nav span.c-nav-item' )
	const headers = Array.from( nav ).map( ( navElement ) => blogContent.querySelector( `#${ navElement.dataset.id }` ) )

	let lastScrollY = window.pageYOffset
	let lastIntersectedIndex = -1;
	let scrollDisabled = false;

	const observer = new IntersectionObserver( ( entries ) => {

		const currentScrollY = window.pageYOffset
		const scrollingDown = currentScrollY > lastScrollY

		entries.forEach( ( entry ) => {

			const id = entry.target.getAttribute( 'id' )
			const navElement = document.querySelector( `.js-content-nav span.c-nav-item[data-id='${ id }']` )
			const currentIndex = Array.from( nav ).indexOf( navElement );

			// Scrolling down
			if ( entry.isIntersecting && scrollingDown ) {

				nav.forEach( ( item ) => {

					item.classList.remove( 'active' )

				} );
				navElement.classList.add( 'active' )
				lastIntersectedIndex = currentIndex;

			}

			// Scrolling up
			if ( ! entry.isIntersecting && ! scrollingDown && lastIntersectedIndex > 0 ) {

				const previousNavElement = nav[ lastIntersectedIndex - 1 ];
				nav.forEach( ( item ) => {

					item.classList.remove( 'active' )

				} );
				previousNavElement.classList.add( 'active' )
				lastIntersectedIndex--;

			}

		} );

		lastScrollY = currentScrollY

	}, { rootMargin: '-50% 0px -50% 0px', threshold: [ 0, 1 ] } );

	headers.forEach( ( header ) => {

		if ( header ) {

			observer.observe( header )

		}

	} );

	nav.forEach( ( navElement ) => {

		navElement.addEventListener( 'click', () => {

			const pageHeader = document.querySelector( '.js-page-header' )
			const pageHeaderHeight = pageHeader ? pageHeader.offsetHeight : 0

			nav.forEach( ( item ) => {

				item.classList.remove( 'active' )

			} )

			navElement.classList.add( 'active' )

			lastIntersectedIndex = Array.from( nav ).indexOf( navElement );

			const scrollElement = blogContent.querySelector( `#${ navElement.dataset.id }` );

			if ( scrollElement ) {

				const scrollElementPosition = scrollElement.getBoundingClientRect().top + window.pageYOffset
				const offsetPosition = scrollElementPosition - pageHeaderHeight - 16

				scrollDisabled = true;

				window.scrollTo( {
					top: offsetPosition,
					behavior: 'smooth',
				} )

				setTimeout( () => {

					scrollDisabled = false;

				}, 100 );

			}

		} )

	} )

	window.addEventListener( 'scroll', () => {

		if ( ! scrollDisabled ) {

			const currentScrollY = window.pageYOffset;
			nav.forEach( ( navElement, index ) => {

				const header = headers[ index ];
				const boundingRect = header.getBoundingClientRect();

				if ( boundingRect.top <= window.innerHeight / 2 && boundingRect.bottom >= 0 ) {

					nav.forEach( ( item ) => {

						item.classList.remove( 'active' )

					} )
					navElement.classList.add( 'active' )
					lastIntersectedIndex = index;

				}

			} );

			lastScrollY = currentScrollY

		}

	} )

}
